import React from 'react';

const LineChartFillSvg = (props) => (
    <svg
        className="line-chart-fill_svg__eds-icon--line-chart-fill__svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="line-chart-fill_svg__eds-icon--line-chart-fill__base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 11c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1m6 3c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1m6-5c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1M2 2v12.5l3.2-2.7c-.1-.2-.2-.5-.2-.8 0-1.1.9-2 2-2s2 .9 2 2v.4l2.5 1.3c.4-.4.9-.7 1.5-.7.4 0 .8.1 1.2.4l3-2.5c-.1-.3-.2-.6-.2-.9 0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2c-.4 0-.8-.1-1.2-.4l-3 2.5c.1.3.2.5.2.9 0 1.1-.9 2-2 2s-2-.9-2-2v-.4l-2.5-1.3c-.4.4-.9.7-1.5.7-.4 0-.8-.1-1.2-.4L2 15.8V22h20V2H2z"
        />
    </svg>
);

LineChartFillSvg.displayName = 'LineChartFillSvg';
export default LineChartFillSvg;
